// Module 19 (BL-380) G6 - hotel block reads and writes. Every call runs under the signed-in user's own RLS (org, the Events pack's two
// keys, the Events area at the event's brand, MFA). Nothing here books a room or sends anything.
import { hotelRow } from './hotelBlock';

export const HOTEL_COLUMNS = 'id, engagement_id, hotel_name, hotel_address, check_in, check_out, rate_note, booking_url, cutoff_date, updated_at';

// True when the table does not exist yet (code live minutes before migration 241 is applied): the screens then show no hotel.
export function missingHotelTable(error) {
    const text = `${error?.code || ''} ${error?.message || ''}`;
    return /42P01|PGRST205|PGRST204|42703/.test(text) || (/event_hotel_blocks/.test(text) && /does not exist|schema cache/.test(text));
}

export async function loadHotelBlock(client, engagementId) {
    const { data, error } = await client.from('event_hotel_blocks').select(HOTEL_COLUMNS).eq('engagement_id', engagementId).maybeSingle();
    if (error) {
        if (missingHotelTable(error)) return null;
        throw error;
    }
    return data || null;
}

// Every block the user can see, as engagement_id -> block (one read for the whole board).
export async function loadHotelBlocks(client) {
    const { data, error } = await client.from('event_hotel_blocks').select('engagement_id, hotel_name, cutoff_date');
    if (error) return new Map();
    return new Map((data || []).map((row) => [row.engagement_id, row]));
}

export async function saveHotelBlock(client, engagementId, existing, values, userId) {
    const row = hotelRow(values);
    const query = existing
        ? client.from('event_hotel_blocks').update({ ...row, updated_by: userId || null }).eq('id', existing.id)
        : client.from('event_hotel_blocks').insert({ engagement_id: engagementId, ...row });
    const { data, error } = await query.select(HOTEL_COLUMNS).single();
    if (error) throw error;
    return existing ? { ...existing, ...data } : data;
}

export async function deleteHotelBlock(client, id) {
    const { error } = await client.from('event_hotel_blocks').delete().eq('id', id);
    if (error) throw error;
}

// Database wording -> plain English for the popup.
export function friendlyHotelError(error) {
    const text = `${error?.message || ''}`;
    if (/booking_url/.test(text)) return 'The booking link must be a full secure web address starting with https://.';
    if (/dates_in_order/.test(text)) return 'Check-out cannot be before check-in.';
    if (/one_per_event/.test(text)) return 'This event already has a hotel block. Refresh to see it.';
    if (/row-level security|permission denied|42501/.test(text)) return 'You do not have permission to change the hotel block.';
    return text || 'The hotel block could not be saved. Please try again.';
}
